import React from "react"
import { useSearchParams } from "react-router-dom"
import { OnClickOutside, SubscribeGlobalState } from "../../../common/hooks/global-state"
import { CloseIcon } from "../ui/icons"

export const Popup: React.FC<{
    className?: string
    children?: React.ReactNode,
    onClose?: () => void;
}> = ({ children, className, onClose }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const popupRef = React.useRef<HTMLDivElement>(null)
    const authorized = SubscribeGlobalState("authorizedUser")

    OnClickOutside(popupRef, () => {
        onClickClose();
    })

    if (!authorized?.authorized) {
        const emptySearchParams = clearSearchParams(searchParams);
        setSearchParams(emptySearchParams)
        return <></>
    }

    return (
        <div className="z-[20] fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.8)] ">
            <div
                ref={popupRef}
                className={`${className || ''} min-w-[300px] max-h-screen min-h-[300px] bg-dark shadow-dark-l 
                    rounded-md p-[44px] lg:p-[44px] overflow-y-auto overflow-x-hidden scrollbar-dark relative`}
            >
                {children}
                <button className="absolute top-5 right-5 text-gray text-[18px] font-bold hover:brightness-[250%]"
                    onClick={onClickClose}
                >
                    <CloseIcon />
                </button>
            </div>
        </div>
    );

    function onClickClose() {
        const emptySearchParams = clearSearchParams(searchParams);
        setSearchParams(emptySearchParams)
        onClose && onClose();
    }
}

function clearSearchParams(params: URLSearchParams): URLSearchParams {
    params.delete("popup")
    return params;
}